const LogoutIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 9.75V8.25H5.25V6L1.5 9L5.25 12V9.75H12Z" fill="#484848" />
      <path
        d="M15 2.25H8.25C7.42275 2.25 6.75 2.92275 6.75 3.75V6.75H8.25V3.75H15V14.25H8.25V11.25H6.75V14.25C6.75 15.0773 7.42275 15.75 8.25 15.75H15C15.8273 15.75 16.5 15.0773 16.5 14.25V3.75C16.5 2.92275 15.8273 2.25 15 2.25Z"
        fill="#484848"
      />
    </svg>
  );
};

export default LogoutIcon;
